import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax
import { Button, Card, Paper } from '@material-ui/core'
import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import mapMarker from '../../../assets/img/mapMarker.svg'
import useWindowSize from '../../../hooks/useWindowSize'
import './locationsMap.scss'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN

const LocationsMap = () => {
  const mapContainer = useRef(null)
  const map = useRef(null)

  const [xPoint, setXPoint] = useState(0)
  const [yPoint, setYPoint] = useState(0)
  const [locationProperties, setLocationProperties] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const size = useWindowSize()

  const [lng, setLng] = useState('')
  const [lat, setLat] = useState('')
  const zoomMultiplier = size.width < 1200 ? 11 : 8
  const zoom = Math.round((size.width / 420) * zoomMultiplier) / 10

  useEffect(() => {
    if (isNaN(zoom)) return // if window size isnt available yet,
    if (map.current) return // initialize map only once

    if (size.width < 1200) {
      setLng(-97)
      setLat(40)
    } else {
      setLng(-75)
      setLat(37)
    }

    if (lng !== '' && lat !== '') {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/evanlgray/ckoviyn5r3dy017plnre4d7sz',
        center: [lng, lat],
        zoom: zoom,
        minZoom: zoom,
        attributionControl: false,
        doubleClickZoom: false,
        touchZoomRotate: false,
        dragPan: false,
        scrollZoom: false,
      })

      map.current.on('click', function (e) {
        var features = map.current.queryRenderedFeatures(e.point, {
          layers: ['locations'], // replace this with the name of the layer
        })

        if (!features.length) {
          setShowPopup(false)

          return
        }

        var feature = features[0]

        setXPoint(e.point.x)
        setYPoint(e.point.y)
        setLocationProperties(feature.properties)
        setShowPopup(true)
      })
    }
  }, [size, lat, lng, zoom])

  const Popup = () => {
    //change location card x position if its too far left...
    const x = xPoint <= 150 ? 180 : xPoint

    return (
      <>
        <img
          className="map-marker"
          style={{ left: xPoint, top: yPoint }}
          src={mapMarker}
          alt="Map Marker"
        />
        <Card className="location" style={{ left: x, top: yPoint }}>
          <div className="inner">
            <h4>{locationProperties.name}</h4>

            <p>
              <strong>Address:</strong>
              <br />
              {locationProperties.addressLine1}
              <br />
              {locationProperties.addressLine2}
            </p>

            <p>
              <strong>Contact us:</strong>
              <br />
              {locationProperties.telephone}
              <br />
              {locationProperties.fax}
            </p>

            <p>
              <strong>Customer Relations Group:</strong>{' '}
              {locationProperties.customerRelations}
              <br />
              <strong>Service & Support:</strong>{' '}
              {locationProperties.serviceAndSupport}
            </p>

            <Link to="/createaquote">
              <Button className="btn-white">Start a quote</Button>
            </Link>
          </div>
        </Card>
      </>
    )
  }

  return (
    <div className="locations-map" style={{ position: 'relative' }}>
      <div ref={mapContainer} className="map-container" />
      <Paper className="info-box">
        <div className="accent"></div>
        <h4>We have Hexagon solution centers all across the USA</h4>
        <p>
          Hexagon Manufacturing Intelligence has offices across the United
          States ready to offer sales and technical services. Find the office
          closest to you.
        </p>

        <a
          href="https://www.hexagonmi.com/en-us/contact-us/locations"
          target="_blank"
          rel="noreferrer"
        >
          <Button className="btn-gradient alt">Show me all locations</Button>
        </a>
      </Paper>

      {showPopup && <Popup />}
    </div>
  )
}

export default LocationsMap
